import { useContext } from "react";
import { useValue } from "@tldraw/state-react";
import type { PlanroomEditor } from "./editor";
import { CanvasEditorContext } from "./editor-context";

// React access to the canvas editor for shape bodies and workspace UI.

export function useEditor(): PlanroomEditor {
  const editor = useContext(CanvasEditorContext);
  if (!editor) throw new Error("useEditor must be used inside the canvas.");
  return editor;
}

export function useIsEditing(shapeId: string) {
  const editor = useEditor();
  return useValue("is editing", () => editor.getEditingShapeId() === shapeId, [editor, shapeId]);
}

/** Select a text-like shape and start typing in it. */
export function startEditingShapeWithRichText(editor: PlanroomEditor, id: string) {
  editor.select(id as never);
  editor.setEditingShape(id as never);
  (editor as unknown as { setCurrentTool(path: string): unknown }).setCurrentTool("select.editing_shape");
}
